import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Image, Row, Modal, Col, Button } from "react-bootstrap";
import { VendorRatingReviewTableHead } from "../../superAdminVendorTable/ratingReviewTable/VendorRatingReviewTableHead";
import { VendorRatingReviewTablebody } from "../../superAdminVendorTable/ratingReviewTable/VendorRatingReviewTablebody";
import BasicPagination from "../../../../../Pagination/Pagination";
import ReactStars from "react-rating-stars-component";

const Seating = (props) => {
  const [showView, setShowView] = useState(false);
  const handleShowView = () => setShowView(true);
  const handleCloseView = () => setShowView(false);
  const [page, setPage] = useState(1);

  const handleBatchChange = (pageNo) => {
    setPage(pageNo);
  };
  const [showHideMessage, seShowHideMessage] = useState(false);
  const handleCloseHideMessage = () => seShowHideMessage(false);
  const handleShowHideMessage = () => seShowHideMessage(true);

  const reviewData = useSelector((state) => {
    return state.adminAllVendorsInfo.superAdminSingleReview;
  });

  const renderAllVendorsBody = () => {
    return (
      <React.Fragment>
        {reviewData &&
          reviewData.map((data, index) => (
            <React.Fragment key={index}>
              <VendorRatingReviewTablebody reviewData={data} />
            </React.Fragment>
          ))}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <div className="user-table-reusable-superadmin super-admin-all-vendor-main">
        <Table className="HideShowTable">
          <thead>
            <VendorRatingReviewTableHead
              userName="User Name"
              ratingsDateTime="Ratings- Date & Time"
              reviewComments="Review / Comment"
              service="Service / Item"
              action="Action"
            />
          </thead>
          {renderAllVendorsBody()}
        </Table>
      </div>
      <BasicPagination
        totalRecords={100}
        limit={10}
        batch={page}
        onBatchChange={(e) => handleBatchChange(e)}
      />
      <Modal show={showHideMessage} onHide={handleCloseHideMessage} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure you want to Hide ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseHideMessage}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={handleCloseHideMessage}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showView} onHide={handleCloseView} centered size="lg">
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="d-flex">
            <div className="enIMG75">
              <Image
                src={require("../../../../../../assets/images/UserManagement/fhr7.png")}
                alt="View"
                title="View"
                fluid
                className="w-100 h-100"
              />
            </div>
            <div className="pl-3 row">
              <Col
                lg={10}
                xl={8}
                className="d-flex flex-column justify-content-between"
              >
                <div className="f24-500">Mc Donald’s Review</div>
                <div className="f14-400">
                  84/36, N Main Rd, Koregaon Park Annexe Mundhwa, Pune,
                  Maharashtra 411001
                </div>
              </Col>
            </div>
          </div>
          <hr />
          <Row>
            <Col
              md={4}
              className="d-flex align-items-center justify-content-start"
            >
              <div className="d-flex flex-column align-items-center justify-content-center">
                <div className="super-admin-suggestion-imageBoxOne enIMG62 rounded-circle">
                  <Image
                    fluid
                    src={require("../../../../../../assets/images/ActionImages/demoprofile.jpg")}
                    alt="Icon"
                  />
                </div>
                <div className="super-admin-suggestion-imageBoxTwo mt-2">
                  <div className="f12-400">Akhil Sharma</div>
                </div>
              </div>
            </Col>
            <Col
              md={4}
              className="d-flex align-items-center justify-content-center"
            >
              <div>
                <div className="f12-500 mb-1">4.0 Stars</div>
                <ReactStars
                  count={5}
                  value={4.0}
                  edit={false}
                  size={22}
                  half={true}
                  emptyIcon={<i className="fa fa-star-o"></i>}
                  halfIcon={<i className="fa fa-star-half-alt"></i>}
                  fullIcon={<i className="fa fa-star"></i>}
                  color2={"#FDD400"}
                />
                <div className="f10-500 mt-1">12th July, 2020 6:30 PM</div>
              </div>
            </Col>
            <Col
              md={4}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="d-flex align-items-center">
                <div className="image-box-new mr-2">
                  <Image
                    fluid
                    src={require("../../../../../../assets/images/seatingImages/reservationBlack.png")}
                  />
                </div>
                <div>
                  <div className="f12-500">RESERVATION</div>
                  <span className="f10-400">1823232322</span>
                </div>
              </div>
            </Col>
          </Row>
          <hr />
          <div className="d-flex align-items-center justify-content-end py-2">
            <div className="d-flex align-items-center">
              <div className="opacity5">
                <Image
                  fluid
                  alt="User Photo"
                  width="24px"
                  src={require("../../../../../../assets/images/superadmin/like.svg")}
                />
              </div>
              <div className="rating-review-table-body-usertextone">
                <div className="f16-400 mx-2">2.6K</div>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <div className="opacity5">
                <Image
                  fluid
                  alt="User Photo"
                  width="24px"
                  className="mt-2"
                  src={require("../../../../../../assets/images/superadmin/disslike.svg")}
                />
              </div>
              <div className="rating-review-table-body-usertextone">
                <div className="f16-400 mx-2">210</div>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <div className="opacity5">
                <Image
                  fluid
                  alt="User Photo"
                  width="24px"
                  src={require("../../../../../../assets/images/superadmin/chat.svg")}
                />
              </div>
              <div className="rating-review-table-body-usertextone">
                <div className="f16-400 mx-2">10</div>
              </div>
            </div>
          </div>
          <div className="enFildset">
            <div className="enlbl f12-400">
              <span className=" opacity5">Review Comments</span>
            </div>
            <div className="f14-400">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry’s standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type survived not only five
              centuries, but also the leap into electronic typesetting,
              remaining essentially unchanged. It was popularised in the 1960s
              with the release of Letraset sheets containing Lorem Ipsum
              passages, and more recently with desktop publishing software like
              Aldus PageMaker including versions of Lorem Ipsum Lorem Ipsum is
              simply dummy text of the printing and typesetting industry. Lorem
              Ipsum has been the industry’s standard dummy text ever since the
              1500s, when an unknown printer took a galley of type and scrambled
              it to make a type survived not only five centuries, but also the
              leap into electronic typesetting, remaining essentially unchanged.
              It was popularised in the 1960s with the release of Letraset
              sheets containing Lorem Ipsum passages, and more recently with
              desktop publishing software like Aldus PageMaker including
              versions of Lorem Ipsum Lorem Ipsum is simply dummy text of the
              printing and typesetting industry. Lorem Ipsum has been the
              industry’s standard dummy text ever since the 1500s, when an
              unknown printer took a galley of type and scrambled it to make a
              type survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was
              popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of
              Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and
              typesetting industry. Lorem Ipsum has been the industry’s standard
              dummy text ever since the 1500s, when an unknown printer took a
              galley of type and scrambled it to make a type survived not only
              five centuries,
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default Seating;
